import Joi from '@hapi/joi'

export const DeductionBreakdownReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Operation Entity is required`,
        "any.required": `Operation Entity is required`
    }),
    divisionID: Joi.number().optional(),
    /*
    divisionID: Joi.number().label("Division").messages({
        "any.invalid": `Select Division`,
        "any.required": `Division required`
    }),
    */
    fromDate: Joi.string().invalid("").label("From Date"),
    toDate: Joi.string().invalid("").label("To Date"),
    pluckingType: Joi.string().allow("0", "").optional(),
    /*
    pluckingType: Joi.string().label("pluckingType").messages({
            "any.invalid": `Please select valid plucking Type`,
            "any.required": `plucking Type required`
    })
            */
}